import { Injectable } from '@angular/core';
import { toLuxon } from '../helpers/function/to-luxon';
import { ApiService } from '../api.service';

@Injectable({ providedIn: 'root' })
export class ApiMessagingHelperService {
  constructor(private _apiService: ApiService) {}

  getMedia(media: any, mediaId = null, sizeId = 'thumb') {
    let url =
      this._apiService.options.apiUrl +
      '/messaging-message/stream/id/' +
      media.id;
    if (mediaId) {
      url += '/media/' + mediaId;
    }
    if (sizeId) {
      url += '/size/' + sizeId;
    }
    if (media.modified) {
      url += '?' + toLuxon(media.modified.date)?.toMillis();
    } else {
      url += '?' + toLuxon(media.created.date)?.toMillis();
    }
    return url;
  }
}
